module.exports = __webpack_public_path__ + "audio/sevenAudio.96b7a70f.mp3";